import { Endpoint } from '../endpoint';
import { GraphResponse } from '@business/entities/graph';
import { GraphValueFormData } from '@modules/statistics/graphs/AddEditGraphValueModal/AddEditGraphValueModal';

export function createValue(data: GraphValueFormData) {
  return Endpoint.post<GraphResponse>(`@makh/graph-values`, { data });
}

export function updateValue(id: string, data: GraphValueFormData) {
  return Endpoint.patch<GraphResponse>(`@makh/graph-values/${id}`, { data });
}

export function fetchValue(id: string) {
  return Endpoint.get<GraphResponse>(`@makh/graph-values/value/${id}`);
}

export function deleteValue(id: string) {
  return Endpoint.delete<GraphResponse>(`@makh/graph-values/${id}`);
}
